<template>
	<div class="container">
		<div class="row">
			<div class="col-md-12 text-center">
				<div class="error-template">
					<h1>
						Oops!
					</h1>
					<img
						src="/assets/img/undraw_not_found_60pq.svg"
						alt="Login Image"
						height="200px" />
					<h2 class="mt-3">
						404 Not Found
					</h2>
					<div class="error-details">
						Sorry, an error has occurred. The page you have requested does not exist!
					</div>
					<div class="error-actions">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PageNotFound',
		components: {}
	}
</script>
